import { useEffect, useState } from "react";
import { Grid, Stack } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import SimpleTextField from "@/Layouts/components/InputComponents/SimpleTextField";
import Title from "../../../common/Title";
import { ISystemSettings } from "@/Settings/types/Common/model";
import { errorLogger } from "@/Common/helpers/logger";
import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";

type TMaxScheduleDaysProps = {
	locationId: string;
	citMaxScheduleDays?: number;
};

const MaxScheduleDays = (props: TMaxScheduleDaysProps) => {
	const { locationId, citMaxScheduleDays } = props;
	const queryClient = useQueryClient();

	const [maxScheduleDays, setMaxScheduleDays] = useState(citMaxScheduleDays);

	const { mutate, isPending } = useMutation({
		mutationKey: ["citMaxScheduleDays", locationId],
		mutationFn: (input: { citMaxScheduleDays: number }) => updateSystemSettings(locationId, input, "MAX_SCHEDULE_DAYS"),
		onSuccess: (result: ISystemSettings) => {
			setMaxScheduleDays(result.citMaxScheduleDays);
			queryClient.setQueryData(["systemSettings", locationId], (cachedData: ISystemSettings) => {
				return {
					...cachedData,
					citMaxScheduleDays: result.citMaxScheduleDays,
				};
			});
		},
		onError: (error) => {
			errorLogger(error);
		},
	});

	const handleChange = (value: string) => {
		const saveValue = value || "0";
		const numberValue = parseInt(saveValue, 10);
		setMaxScheduleDays(numberValue);
		const input = {
			citMaxScheduleDays: numberValue,
		};
		mutate(input);
	};

	useEffect(() => {
		setMaxScheduleDays(citMaxScheduleDays);
	}, [citMaxScheduleDays]);

	return (
		<Grid container direction={"column"}>
			<Grid item>
				<Stack>
					<Title title="Max Schedule Days" className="!mb-[24px]" />
					<SimpleTextField
						sx={{ width: "150px" }}
						editable
						disabled={isPending}
						outlined
						text={String(maxScheduleDays) || ""}
						onActionUpdate={handleChange}
						onlyNumbers
					/>
				</Stack>
			</Grid>
		</Grid>
	);
};

export default MaxScheduleDays;
